var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33bc7913ecc40d4642129ae851012be6.js').default;export default
        Object.assign({}, scope_0 )
    